import {inject, Injectable} from '@angular/core';
import {BaseApiService} from "./base-api.service";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly apiService = inject(BaseApiService);

  async auth(email: string, password: string) {
    const body = {
      grant_type: 'password',
      username: email,
      password: password,
      scope: '',
      refresh_token: ''
    };
    return await this.apiService.post(`/auth/token`, body);
  }

  async forgotPassword(email: string) {
    const body = {
      email: email
    };
    return await this.apiService.post(`/reset-password`, body);
  }

  async resetPassword(body: any) {
    return await this.apiService.post(`/reset-password/reset-password`, body);
  }

  async registration(body: any) {
    return await this.apiService.post(`/account/register`, body);
  }

  async introspect_forgot_password_token(token: string) {
    const body = {
      token: token
    };
    return await this.apiService.post(`/reset-password/introspect-token`, body);
  }

  async verifyEmail(token: any) {
    const body = {
      token: token
    };
    return await this.apiService.post(`/account/verify-account`, body);
  }

  async resentEmailVerification(email: any) {
    const body = {
      email: email
    };
    return await this.apiService.post(`/account/resent-verification`, body);
  }

  async getCurrentUser() {
    return await this.apiService.post(`/account/identity`, {});
  }

  async logout() {
    return await this.apiService.post(`/account/logout`, {});
  }
}
